export enum FilterRequestAge {
    Last3Months = 'Last 3 Months',
    Last6Months = 'Last 6 Months',
    Last12Months = 'Last 12 Months',
    All = 'All'
}